import { useEffect, useState } from "react";
import Input, {
    FormState,
    required,
    submitForm,
    useTextInput,
} from "../../../../components/input";
import { api } from "../../../../env";
import { useNavigate, useParams } from "react-router-dom";
import Title from "../../../../components/Title";
import Questions from "./Questions";
import { ConfirmButton } from "../../../../components/ConfirmButton";

export default function CreateQuestionnaire({ isDuplicate = false}) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [state, setState] = useState(FormState.CREATE);

    useEffect(() => {
        if (id) {
            api.get(`questionnaires/${id}`).then((res) =>
                setQuestionnaire(res.data),
            );
        }
    }, [id]);

    const setQuestionnaire = (questionnaire) => {
        setQuestions(
            questionnaire.questions.map((it) => {
                return { ...it, id: isDuplicate ? "" : it.id, };
            }),
        );
        questioneerForm.name._setValue(isDuplicate ? "" : questionnaire.name);
        setState(isDuplicate ? FormState.CREATE : FormState.UPDATE);
    };

    const questioneerForm = {
        name: useTextInput("Name", "label", [required]),
    };

    const handleOnAdd = (question, idx = -1) => {
        if (idx == -1) setQuestions((it) => [...it, question]);
        else setQuestions((it) => it.map((q, i) => (i == idx ? question : q)));
    };

    const handleOnDelete = (index) => {
        setQuestions((it) => it.filter((_, i) => i != index));
    };

    const handleCreate = () => {
        const questioneerInfo = submitForm(questioneerForm);
        if (!questioneerInfo) return;
        let questioneer = {
            ...questioneerInfo,
            questions: questions.map(({ id, ...rest }) => ({
                ...(id !== "" && { id }),
                ...rest,
            })),
        };
        api.post("questionnaires", questioneer)
            .then((res) => {
                navigate("..");
            })
            .catch((err) => {});
    };

    const handleUpdate = () => {
        const questioneerInfo = submitForm(questioneerForm);
        if (!questioneerInfo) return;
        let questioneer = {
            ...questioneerInfo,
            questions: questions.map(({ id, ...rest }) => ({
                ...(id !== "" && { id }),
                ...rest,
            })),
        };
        api.put(`questionnaires/${id}`, questioneer)
            .then((res) => {
                setQuestionnaire(res.data);
                navigate("..");
            })
            .catch((err) => {
                // navigate('..')
            });
    };

    const handleSave = () => {
        if (isDuplicate) {
            handleCreate();
        } else {
            handleUpdate();
        }
    };

    const publish = () => {
        const questioneerInfo = submitForm(questioneerForm)
        if (!questioneerInfo) return
        
        api.put(`questionnaires/${id}`)
            .then((res) => {
                api.put(`questionnaires/${id}/publish`)
                    .then((res) => navigate(".."))
                    .catch((_) => {})
            })
            .catch((err) => {
                // navigate('..')
            })
    };

    return (
        <div className="standard-padding page-xl-centered showing">
            <div className="flex space-between center v-spacer-m">
                <Title>Create Questionnaire</Title>
                <div className="flex gap-xs center">
                    {state == FormState.CREATE && (
                        <button
                            className={`solid-accent ${questions.length == 0 ? "disabled" : ""}`}
                            disabled={questions.length == 0}
                            onClick={handleCreate}
                        >
                            Create
                        </button>
                    )}
                    {state == FormState.UPDATE && (
                        <>
                            <ConfirmButton
                                label={"Publish"}
                                onClick={publish}
                            />
                            <button
                                className={`outline ${questions.length == 0 ? "disabled" : ""}`}
                                disabled={questions.length == 0}
                                onClick={handleSave}
                            >
                                Save Changes
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="card flex columns gap-xs">
                <Input state={questioneerForm.name} />
            </div>
            <div className="v-spacer-xl" />
            <Questions
                questions={questions}
                onAdd={handleOnAdd}
                onDelete={handleOnDelete}
            />
        </div>
    );
}
